import { jsx as _jsx } from "react/jsx-runtime";
import { TableStyled } from './styles';
const Table = (props) => {
    return _jsx(TableStyled, Object.assign({}, props));
};
export default Table;
